import { CLIENTS, fileUrl, useSettings } from "../../lib/api";

const Item = ({ c }) => (
  <span className="flex items-center gap-10 pr-10 md:gap-16 md:pr-16">
    {c.logo ? (
      <img data-testid="client-logo-item" src={fileUrl(c.logo)} alt={c.name} loading="lazy" className="h-14 w-auto max-w-[220px] object-contain transition-transform duration-300 hover:scale-105 md:h-20" />
    ) : (
      <span data-testid="client-logo-item" className="font-display whitespace-nowrap text-5xl font-extrabold uppercase tracking-tight text-slate-900 transition-colors duration-300 hover:text-[#0a6cff] md:text-7xl">
        {c.name}
      </span>
    )}
    <img src="/logo-mark-sm.png" alt="" className="h-8 w-8 object-contain opacity-90 md:h-10 md:w-10" />
  </span>
);

export const ClientMarquee = () => {
  const s = useSettings();
  const list = Array.isArray(s.clients) && s.clients.some((c) => c?.name) ? s.clients.filter((c) => c?.name) : CLIENTS.map((name) => ({ name, logo: "" }));
  return (
    <section data-testid="client-marquee-container" className="border-y border-slate-200 bg-white py-14 md:py-20">
      <div className="container-x mb-10 flex flex-col justify-between gap-3 md:flex-row md:items-end">
        <p className="eyebrow text-[#0a6cff]">Trusted by OEMs & brands</p>
        <p className="max-w-md text-sm text-slate-600">80+ manufacturers and distributors across India source rubber components from Autocrat.</p>
      </div>
      <div className="marquee-wrap relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white md:w-40" />
        <div className="marquee-track flex w-max items-center">
          {[...list, ...list, ...list, ...list].map((c, i) => <Item key={i} c={c} />)}
        </div>
      </div>
    </section>
  );
};
